module.exports = __webpack_public_path__ + "static/media/party-popper.6b9cf89b.png";